exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-29bae61e] .ant-form-item {\n  margin-bottom: 12px;\n}\n", ""]);

// exports
